import React from 'react'
import { Button, HStack } from '@chakra-ui/react'
import { ArrowBackIcon, EditIcon, DeleteIcon } from '@chakra-ui/icons'
import { Link } from 'react-router-dom'

interface ResearchDetailHeaderProps {
  canManageResearch: boolean
  researchId: string
  onDelete: () => void
}

const ResearchDetailHeader: React.FC<ResearchDetailHeaderProps> = ({
  canManageResearch,
  researchId,
  onDelete,
}) => {
  return (
    <HStack justify='space-between' align='start' mb={6}>
      <Button
        as={Link}
        to='/research'
        leftIcon={<ArrowBackIcon />}
        variant='ghost'
        size='sm'
      >
        Back to Research
      </Button>

      {canManageResearch && (
        <HStack spacing={2}>
          <Button
            as={Link}
            to={`/research/edit/${researchId}`}
            leftIcon={<EditIcon />}
            colorScheme='blue'
            size='sm'
          >
            Edit
          </Button>
          <Button
            leftIcon={<DeleteIcon />}
            colorScheme='red'
            variant='outline'
            size='sm'
            onClick={onDelete}
          >
            Delete
          </Button>
        </HStack>
      )}
    </HStack>
  )
}

export default ResearchDetailHeader
